export const DEFAULT_FILTER_GROUP_ID = 0;

export const nextFilterGroupId = filters => {
  const groupIds = (filters || [])
    .map(filter => filter.filter_group_id)
    .filter(id => id !== undefined && id !== null);

  if (!groupIds.length) {
    return DEFAULT_FILTER_GROUP_ID + 1;
  }

  return Math.max(...groupIds) + 1;
};

export const groupFiltersForDisplay = filters => {
  const groups = [];
  const groupMap = new Map();

  (filters || []).forEach((filter, index) => {
    const groupId =
      filter.filter_group_id === undefined || filter.filter_group_id === null
        ? DEFAULT_FILTER_GROUP_ID
        : filter.filter_group_id;

    if (!groupMap.has(groupId)) {
      const group = { id: groupId, items: [] };
      groupMap.set(groupId, group);
      groups.push(group);
    }

    groupMap.get(groupId).items.push({ filter, index });
  });

  if (usesExplicitFilterGroups(filters)) {
    return groups.sort((first, second) => first.id - second.id);
  }

  return groups;
};

export const lastFilterGroupId = filters => {
  const groups = groupFiltersForDisplay(filters);
  if (!groups.length) {
    return DEFAULT_FILTER_GROUP_ID;
  }

  return groups[groups.length - 1].id;
};

export const usesExplicitFilterGroups = filters =>
  (filters || []).some(
    filter => filter.filter_group_id !== undefined && filter.filter_group_id !== null
  );

export const assignFilterGroupId = (filter, groupId) => ({
  ...filter,
  filter_group_id: groupId,
});

export const preserveSavedFilterGroupId = filter => {
  if (
    filter?.filter_group_id === undefined ||
    filter?.filter_group_id === null ||
    filter?.filter_group_id === ''
  ) {
    return {};
  }

  return { filter_group_id: Number(filter.filter_group_id) };
};

export const normalizeFilterGroupIds = filters => {
  const normalized = (filters || []).map(filter => ({ ...filter }));
  if (!usesExplicitFilterGroups(normalized)) {
    return normalized;
  }

  let currentGroupId = DEFAULT_FILTER_GROUP_ID;

  return normalized.map((filter, index) => {
    if (
      filter.filter_group_id !== undefined &&
      filter.filter_group_id !== null &&
      (index === 0 ||
        filter.filter_group_id !== normalized[index - 1].filter_group_id)
    ) {
      currentGroupId = filter.filter_group_id;
    }

    return assignFilterGroupId(filter, currentGroupId);
  });
};
